import { request } from "./http";

export interface LPSession {
  id: string;
  name: string;
  asset_class: string;
  protocol: "FIX44" | "REST" | "WS" | "MOCK";
  host: string | null;
  port: number | null;
  sender_comp_id: string | null;
  target_comp_id: string | null;
  creds_set: boolean;
  heartbeat_int: number;
  last_in_seq: number;
  last_out_seq: number;
  status: string;
  last_error: string | null;
  enabled: boolean;
  priority: number;
  instruments: string[];
  settings: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface LPSessionCreate {
  name: string;
  asset_class?: string;
  protocol?: string;
  host?: string;
  port?: number;
  sender_comp_id?: string;
  target_comp_id?: string;
  username?: string;
  password?: string;
  heartbeat_int?: number;
  enabled?: boolean;
  priority?: number;
  instruments?: string[];
  settings?: Record<string, unknown>;
}

export type LPSessionPatch = Partial<LPSessionCreate>;

export interface LPSessionHealth {
  id: string;
  status: string;
  last_error: string | null;
  last_in_seq: number;
  last_out_seq: number;
  live: {
    connected: boolean;
    last_message_at: string | null;
    in_seq: number;
    out_seq: number;
    fill_rate_pct: number | null;
    reject_rate_pct: number | null;
  } | null;
}

export interface LPMessage {
  id: number;
  direction: "IN" | "OUT";
  msg_type: string;
  seq_num: number | null;
  raw: string;
  ts: string;
}

export const lpSessions = {
  list: () => request<LPSession[]>("/api/v1/lp-sessions"),
  get: (id: string) => request<LPSession>(`/api/v1/lp-sessions/${id}`),
  create: (body: LPSessionCreate) =>
    request<LPSession>("/api/v1/lp-sessions", { body }),
  patch: (id: string, body: LPSessionPatch) =>
    request<LPSession>(`/api/v1/lp-sessions/${id}`, { method: "PATCH", body }),
  remove: (id: string) =>
    request<void>(`/api/v1/lp-sessions/${id}`, { method: "DELETE" }),
  health: (id: string) =>
    request<LPSessionHealth>(`/api/v1/lp-sessions/${id}/health`),
  testLogon: (id: string) =>
    request<{ id: string; status: string; last_error: string | null; connected: boolean }>(
      `/api/v1/lp-sessions/${id}/test-logon`,
      { body: {} }
    ),
  messages: (id: string, limit = 50) =>
    request<LPMessage[]>(`/api/v1/lp-sessions/${id}/messages?limit=${limit}`),
};
